var axios = require('axios')
var url = process.env.prefix_menu
// menu
axios.getMenuList = function (params, cancel, success, callBackError) {
  this.get(url + '/menu?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getMenuListForCombobox = function (params, success, callBackError) {
  this.get(url + '/menu?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateMenuStatus = function (params, success, callBackError) {
  this.put(url + '/menu-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.cloneMenu = function (params, success, callBackError) {
  this.post(url + '/menu-base/clone', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.cloneCombo = function (params, success, callBackError) {
  this.post(url + '/combos/clone', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getListDisplayCategories = function (params, success, callBackError) {
  this.get(url + '/display-categories?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getListSimpleDisplayCategories = function (params, success, callBackError) {
  this.get(url + '/display-categories-simple?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getListCategories = function (success, callBackError) {
  this.get(url + '/category-simple')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createMenu = function (params, success, callBackError) {
  this.post(url + '/menu-base', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateMenu = function (params, success, callBackError) {
  this.put(url + '/menu-base', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateMenuStoreContent = function (params, success, callBackError) {
  this.put(url + '/menu-store-content/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.deleteMenuStoreContent = function (params, success, callBackError) {
  this.delete(url + '/menu-store-delete/' + params.uuid, {
    params: params
  })
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateMenuLayer = function (params, success, callBackError) {
  this.put(url + '/menu-layer', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.updateMenuTopping = function (params, success, callBackError) {
  this.put(url + '/menu-topping', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getMenuDetail = function (params, success, callBackError) {
  this.get(url + '/menu/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getSingleTypeSimple = function (success, callBackError) {
  this.get(url + '/single-type-simple')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadImages = function (params, configs, success, callBackError) {
  this.post(url + '/menu/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishMenu = function (params, success, callBackError) {
  this.post(url + '/menu-publish', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.pullMenuFromPos = function (params, success, callBackError) {
  this.post(url + '/pull-menu-from-pos', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getExtraAndDefaultToppings = function (success, callBackError) {
  this.get(url + '/topping-grouped')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

// combo
axios.getComboList = function (params, success, callBackError) {
  this.get(url + '/combos?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateComboStatus = function (params, success, callBackError) {
  let uuid = params['uuid']
  delete params['uuid']
  let active = params
  this.put(url + '/combos/' + uuid, active)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getComboDetail = function (params, success, callBackError) {
  this.get(url + '/combos/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadComboImages = function (params, configs, success, callBackError) {
  this.post(url + '/combos/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createCombo = function (params, success, callBackError) {
  this.post(url + '/combos', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createComboGroup = function (params, success, callBackError) {
  this.post(url + '/combo-groups', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateComboGroup = function (params, success, callBackError) {
  let uuid = params['uuid']
  this.put(url + '/combo-groups/' + uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.deleteComboGroup = function (params, success, callBackError) {
  this.delete(url + '/combo-groups/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateCombo = function (params, success, callBackError) {
  let uuid = params['uuid']
  this.put(url + '/combos/' + uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
/**
 * @Params : outlet_code
 * @Method : get menu control
 */
axios.getMenuControl = function (params, success, callBackError) {
  this.get(url + '/menu-detail/', {params: params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
/**
 * @Params : outlet_code
 * @Method : get menu control for combo
 */
axios.getMenuControlCombo = function (params, success, callBackError) {
  this.get(url + '/combo-base/', {params: params}).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
/**
 * @Params : outlet_code
 * @Method : Save menu control
 */
axios.saveMenuControl = function (params, success, callBackError) {
  this.post(url + '/menu-outlets', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}
axios.publishMenuControl = function (params, success, callBackError) {
  this.post(url + '/menu-control-publish', params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status == 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.publishCombo = function (params, success, callBackError) {
  this.post(url + '/combos/publish', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishComboBySingle = function (params, success, callBackError) {
  this.post(url + '/combos/publish-by-single', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.listFirstAndSeconds = function (params, success, callBackError) {
  this.get(url + '/list_firsts_and_seconds', {params: params})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.listHalfFirstAndSeconds = function (params, success, callBackError) {
  this.get(url + '/list_half_firsts_and_seconds', {params: params})
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.readyPublicMenu = function (uuid, success, callBackError) {
  this.put(url + '/menu/' + uuid, {'content_status': 3})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.readyPublicCombo = function (uuid, success, callBackError) {
  this.put(url + '/combos/' + uuid, {'content_status': 3})
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getMenuGroupList = function (params, cancel, success, callBackError) {
  this.get(url + '/group?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getMenuGroupDetail = function (params, success, callBackError) {
  this.get(url + '/group/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.addMenuGroup = function (params, success, callBackError) {
  this.post(url + '/group', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.updateMenuGroup = function (params, success, callBackError) {
  this.put(url + '/group', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.getListDealMenu = function (params, success, callBackError) {
  this.get(url + '/products' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateMenuGroupStatus = function (params, success, callBackError) {
  this.put(url + '/group-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.listMenuByCateogory = function (params, success, callBackError) {
  this.get(url + '/products-by-category?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateSequence = function (params, success, callBackError) {
  this.put(url + '/products-sequence', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishMenuGroup = function (params, success, callBackError) {
  this.put(url + '/group-apply/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getContentStatus = function (params, success, callBackError) {
  this.get(url + '/menu-content-status?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getComboContentStatus = function (params, success, callBackError) {
  this.get(url + '/combo-content-status?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getFirstLayer = function (success, callBackError) {
  this.get(url + '/first-layer-simple')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getFirstLayerList = function (params, success, callBackError) {
  this.get(url + '/first-layer?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateFirstLayerStatus = function (params, success, callBackError) {
  this.put(url + '/first-layer-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishFirstLayer = function (success, callBackError) {
  this.post(url + '/first-layer-publish')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getDetailFirstLayer = function (params, success, callBackError) {
  this.get(url + '/first-layer/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadImageFirstLayer = function (params, config, success, callBackError) {
  this.post(url + '/first-layer/upload-image', params, config)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createFirstLayer = function (params, success, callBackError) {
  this.post(url + '/first-layer', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateFirstLayer = function (params, success, callBackError) {
  this.put(url + '/first-layer/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getSecondLayerList = function (params, success, callBackError) {
  this.get(url + '/second-layer?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateSecondLayerStatus = function (params, success, callBackError) {
  this.put(url + '/second-layer-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishSecondLayer = function (success, callBackError) {
  this.post(url + '/second-layer-publish')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getDetailSecondLayer = function (params, success, callBackError) {
  this.get(url + '/second-layer/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadImageSecondLayer = function (params, config, success, callBackError) {
  this.post(url + '/second-layer/upload-image', params, config)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createSecondLayer = function (params, success, callBackError) {
  this.post(url + '/second-layer', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateSecondLayer = function (params, success, callBackError) {
  this.put(url + '/second-layer/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getSecondLayer = function (success, callBackError) {
  this.get(url + '/second-layer-simple')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getToppingList = function (params, success, callBackError) {
  this.get(url + '/topping-list?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getToppingExclusionList = function (params, success, callBackError) {
  this.get(url + '/topping-menu-control?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateToppingStatus = function (params, success, callBackError) {
  this.put(url + '/topping-status', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getDetailTopping = function (params, success, callBackError) {
  this.get(url + '/topping/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.createTopping = function (params, success, callBackError) {
  this.post(url + '/topping-simple', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateTopping = function (params, success, callBackError) {
  this.put(url + '/topping-simple', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.uploadImageTopping = function (params, config, success, callBackError) {
  this.post(url + '/topping/upload-image', params, config)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.publishTopping = function (params, success, callBackError) {
  this.post(url + '/topping-publish', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updateDayPart = function (params, success, callBackError) {
  this.put(url + '/menu-metadata', params)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getDayPart = function (params, success, callBackError) {
  this.get(url + '/menu-metadata/' + params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getDetailToppingRuleMapping = function (params, success, callBackError) {
  this.get(url + '/topping-rule-mapping?uuid=' + params.uuid + '&topping_special=' + params.topping_special + '&type=' + params.type)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createToppingRuleMapping = function (params, success, callBackError) {
  this.post(url + '/topping-rule-mapping', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateToppingRuleMapping = function (params, success, callBackError) {
  this.put(url + '/topping-rule-mapping' , params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuExclusions = function (params, cancel, success, callBackError) {
  this.get(url + '/menu-control-export')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.importMenuWithCsv = function (params, configs, success, callBackError) {
  this.post(url + '/menu/import-my', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.importMenuPriceWithCsv = function (params, configs, success, callBackError) {
  this.post(url + '/menu/import-price-nz', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.blockMenuWithCsv = function (params, configs, success, callBackError) {
  this.post(url + '/block-item-csv', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.unblockMenuWithCsv = function (params, configs, success, callBackError) {
  this.post(url + '/unblock-item-csv', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuAttributeList = function (params, success, callBackError) {
  this.get(url + '/attribute?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.uploadMenuAttributeImages = function (params, configs, success, callBackError) {
  this.post(url + '/attribute/upload-image', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createMenuAttribute = function (params, success, callBackError) {
  this.post(url + '/attribute', params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.updateMenuAttribute = function (params, success, callBackError) {
  this.put(url + '/attribute/'+params.uuid, params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuAttribute = function (params, success, callBackError) {
  this.get(url + '/attribute/' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.publishMenuAttribute = function (success, callBackError) {
  this.post(url + '/attribute-publish')
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.getMenuAttributeSimple = function (params, success, callBackError) {
  this.get(url + '/attribute-simple?' + params)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.handleCrustAndSizeWithCsv = function (params, configs, success, callBackError) {
  this.post(url + '/crust-size-control', params, configs)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.exportMenu = function (params, success, callBackError) {
  this.get(url + '/' + params.type + '/' + params.uuid + '/export-price')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.listFirstAndSecondOutOfStock = function (outletCode, success, callBackError) {
  this.get(url + `/out-of-stock/${outletCode}/first-and-second`).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.pushFirstAndSecondOutOfStock = function (outletCode, params, success, callBackError) {
  this.post(url + `/out-of-stock/${outletCode}/first-and-second`, params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.listToppingOutOfStock = function (outletCode, params, success, callBackError) {
  this.get(url + `/out-of-stock/${outletCode}/topping`, { params: params }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.pushToppingOutOfStock = function (outletCode, params, success, callBackError) {
  this.post(url + `/out-of-stock/${outletCode}/topping`, params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.listMenuOutOfStock = function (outletCode, params, success, callBackError) {
  this.get(url + `/out-of-stock/${outletCode}/menu`, { params: params }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.listComboOutOfStock = function (outletCode, params, success, callBackError) {
  this.get(url + `/out-of-stock/${outletCode}/combo`, { params: params }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.pushMenuOutOfStock = function (outletCode, params, success, callBackError) {
  this.post(url + `/out-of-stock/${outletCode}/menu`, params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.pushComboOutOfStock = function (outletCode, params, success, callBackError) {
  this.post(url + `/out-of-stock/${outletCode}/combo`, params).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.exportOutOfStock = function (success, callBackError) {
  this.get(url + '/out-of-stock/export', { responseType: 'blob' }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

axios.storePublishTrack = function (outletCode, success, callBackError) {
  this.get(url + `/products/${outletCode}/publish-track`).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      callBackError(error.response.data)
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/Menu.js